import Icon from './icon/icon';

const primaryLinks = [
	{
		name: 'Spotify',
		url: 'https://open.spotify.com/artist/3na2KF7Hmo35K6BSrheLt3',
		icon: 'spotify',
		description: 'Official artist profile on Spotify.',
		label: 'Stream',
	},
	{
		name: 'Apple Music',
		url: 'https://music.apple.com/us/artist/aconitum/1816189853',
		icon: 'website',
		description: 'Official artist page on Apple Music.',
		label: 'Stream',
	},
	{
		name: 'Instagram',
		url: 'https://www.instagram.com/djaconitum/',
		icon: 'instagram',
		description: 'Reels, stories and current updates.',
		label: 'Social',
	},
	{
		name: 'YouTube',
		url: 'https://youtube.com/@djaconitum',
		icon: 'youtube',
		description: 'Mixes, edits and upcoming long-form content.',
		label: 'Video',
	},
	{
		name: 'SoundCloud',
		url: 'https://soundcloud.com/djaconitum',
		icon: 'soundcloud',
		description: 'Tracks, previews and selected uploads.',
		label: 'Music',
	},
	{
		name: 'TikTok',
		url: 'https://tiktok.com/@djaconitum',
		icon: 'tiktok',
		description: 'Short clips and live snippets.',
		label: 'Clips',
	},
	{
		name: 'Patreon',
		url: 'https://patreon.com/djaconitum',
		icon: 'patreon',
		description: 'Support and future exclusive content.',
		label: 'Support',
	},
];

const secondaryLinks = [
	{
		name: 'Twitch',
		url: 'https://www.twitch.tv/djaconitum',
		icon: 'twitch',
	},
	{
		name: 'X',
		url: 'https://twitter.com/djaconitum',
		icon: 'twitter',
	},
	{
		name: 'Email',
		url: 'mailto:contact@djaconitum.com',
		icon: 'website',
	},
	{
		name: 'Gravatar',
		url: 'https://gravatar.com/djaconitum',
		icon: 'website',
	},
	{
		name: 'Facebook',
		url: 'https://www.facebook.com/djaconitum',
		icon: 'facebook',
	},
];

export default function Content() {
	return (
		<main className="landing-page">
			<section className="landing-hero">
				<div className="landing-hero__intro">
					<p className="landing-kicker">DJ Aconitum</p>
					<h1>
						Electronic
						<br />
						energy,
						<br />
						directly linked.
					</h1>
				</div>
				<div className="landing-hero__aside">
					<p className="landing-copy">
						A stripped-back landing page for the current phase. The
						full one-page site with visuals and motion comes later.
					</p>
					<div className="landing-meta">
						<span>Darmstadt, Germany</span>
						<span>DJ / Producer</span>
					</div>
					<div className="hero-actions">
						<a className="hero-action hero-action--primary" href="mailto:contact@djaconitum.com">
							Contact
						</a>
						<a className="hero-action" href="/contact">
							Details
						</a>
					</div>
				</div>
			</section>

			<section className="landing-section">
				<div className="section-heading">
					<p>Follow</p>
					<h2>All main channels</h2>
				</div>
				<div className="link-list" aria-label="Main links">
					{primaryLinks.map(({ name, url, icon, description, label }, index) => (
						<a
							key={name}
							className="link-row"
							href={url}
							target="_blank"
							rel="noreferrer">
							<span className="link-row__index">
								{String(index + 1).padStart(2, '0')}
							</span>
							<span className="link-row__icon" aria-hidden="true">
								<Icon name={icon} />
							</span>
							<span className="link-row__body">
								<strong>{name}</strong>
								<span>{description}</span>
							</span>
							<span className="link-row__tag">{label}</span>
						</a>
					))}
				</div>
			</section>

			<section className="landing-section">
				<div className="landing-panel">
					<div>
						<p className="panel-kicker">Contact</p>
						<h2>Bookings, questions, collaborations.</h2>
						<p>
							Use the direct mail address or open the contact page for
							the current contact points.
						</p>
					</div>
					<a className="panel-link" href="mailto:contact@djaconitum.com">
						contact@djaconitum.com
					</a>
				</div>
			</section>

			<section className="landing-section">
				<div className="section-heading">
					<p>More</p>
					<h2>Further platforms</h2>
				</div>
				<section className="secondary-links" aria-label="More links">
					{secondaryLinks.map(({ name, url, icon }) => (
						<a key={name} href={url} target="_blank" rel="noreferrer">
							<Icon name={icon} />
							<span>{name}</span>
						</a>
					))}
				</section>
			</section>
		</main>
	);
}
